import { Locale } from '../enums/locale';
import { z } from 'zod';

export const CreatePrivacyPolicyDto = z.object({
  language: z.enum([Locale.EN_US, Locale.SR_LATN]),
});

export type ApiCreatePrivacyPolicyDto = z.infer<typeof CreatePrivacyPolicyDto>;
